<template>
  <div class="layer paymentLayer">
    <button v-if="payInfo && payInfo.checkout === 'A'" type="button" class="btnClose" @click="cancel"></button>
    <div v-if="payInfo && payInfo.checkout === 'A'" class="inner">
      <p class="layerTitle">{{locale.payment_progress}}</p>
      <!-- standard -->
      <div id="paypal-button-container" class="mb5"></div>
      <!-- //standard -->
      <!-- advanced -->
      <div id="paypal-credit">
        <div class="mb10">
          <button type="button" class="btn btnFull" @click="paypalCredit = true">{{locale.creditcard_payment}}</button>
        </div>
        <form v-show="paypalCredit" id="card-form">
          <div class="row">
            <div class="cell">
              <p class="cardLabel">Card number</p>
              <div id="cc-number" class="input">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <p class="cardLabel">CVC/CVV</p>
              <div id="cc-cvv" class="input"></div>
            </div>
            <div class="cell">
              <p class="cardLabel">Expiration date</p>
              <div id="cc-expiration" class="input"></div>
            </div>
          </div>
          <button type="submit" value="submit" id="paypal_submit" class="btn btnFull">{{locale.pay}}</button>
        </form>
      </div>
      <!-- //advanced -->
    </div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js'
import UNIQUE from '@/common/unique'

export default {
  name: 'PaypalPayment',
  props: [
    'locale',
    'order'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        const advanced = this.payInfo && this.payInfo.checkout === 'A' // A: advanced, S: standard
        setTimeout(() => {
          // window.location.href = this.payInfo.url
          if (advanced) {
            this.init()
          } else {
            window.location.href = this.payInfo.url
          }
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false,
      paypalCredit: false
    }
  },
  methods: {
    async init () {
      let paypal
      const requestId = UNIQUE.mid()
      const Moid = this.payInfo.Moid
      const currency = this.order.price.info.currency
      const amount = this.order.price.info.total
      const clientId = this.payInfo.clientId
      const clientToken = this.payInfo.clientToken
      const authToken = this.payInfo.authToken
      const successUrl = this.payInfo.successURL
      const cancelUrl = this.payInfo.cancelURL
      const returnURL = this.order.returnURL
      const Store = this.$store
      const Router = this.$router
      const Locale = this.locale
      let err
      let orderId
      this.$store.commit('loading', true)
      // load paypal
      try {
        paypal = await loadScript({
          'client-id': clientId,
          'data-client-token': clientToken,
          'data-page-type': 'checkout',
          components: ['buttons', 'hosted-fields'],
          currency: currency
        })
        this.$store.commit('loading', false)
      } catch (error) {
        console.error('failed to load the PayPal JS SDK script', error)
        this.$store.commit('loading', false)
      }
      // create order by paypal
      try {
        await paypal.Buttons({
          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: amount // 결제금액
                }
              }]
            })
          }
        }).render('#paypal-button-container')
        this.$store.commit('loading', false)
      } catch (error) {
        console.error('failed to render the PayPal Buttons', error)
        this.$store.commit('loading', false)
      }
      // create paypal hosted fields
      if (paypal && paypal.HostedFields.isEligible()) {
        /**
         * 호스트 된 결제프레임 flow
         * frontend:: order -> capture -> complete ->
         * backend:: (로그를 남기기 위한) api(POST) ->
         * frontend:: route to complete url
         * */
        try {
          // 결제 프레임 instance 호출
          await paypal.HostedFields.render({
            createOrder: async () => {
              const res = await fetch('https://api-m.sandbox.paypal.com/v2/checkout/orders', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`,
                  'PayPal-Request-Id': requestId
                },
                body: JSON.stringify({
                  intent: 'CAPTURE',
                  purchase_units: [
                    {
                      amount: {
                        currency_code: currency,
                        value: amount
                      }
                    }
                  ],
                  application_context: {
                    return_url: successUrl,
                    cancel_url: cancelUrl
                  }
                })
              })
              const createOrderResult = await res.json()
              orderId = createOrderResult.id
              return createOrderResult.id
            },
            fields: {
              number: {
                selector: '#cc-number',
                placeholder: '●●●● ●●●● ●●●● ●●●●'
              },
              cvv: {
                selector: '#cc-cvv',
                placeholder: '●●●'
              },
              expirationDate: {
                selector: '#cc-expiration',
                placeholder: 'MM/YY'
              }
            }
          }).then(function (hostedFieldsInstance) {
            hostedFieldsInstance.on('empty', function (event) {
              const field = event.fields[event.emittedBy]
              field.container.classList.remove('isValid')
              field.container.classList.add('isInvalid')
            })
            hostedFieldsInstance.on('notEmpty', function (event) {
              const field = event.fields[event.emittedBy]
              if (field.isValid) {
                field.container.classList.add('isValid')
                field.container.classList.remove('isInvalid')
              } else {
                field.container.classList.remove('isValid')
                field.container.classList.add('isInvalid')
              }
            })
            // validity change event
            hostedFieldsInstance.on('validityChange', function (event) {
              const field = event.fields[event.emittedBy]
              if (field.isValid) {
                field.container.classList.add('isValid')
                field.container.classList.remove('isInvalid')
              } else {
                field.container.classList.remove('isValid')
                field.container.classList.add('isInvalid')
              }
            })
            // 실제 결제 event
            document.querySelector('#card-form').addEventListener('submit', (event) => {
              event.preventDefault()
              const state = hostedFieldsInstance.getState()
              // form validation
              const formValid = Object.keys(state.fields).every(function (key) {
                return state.fields[key].isValid
              })
              if (formValid) {
                // order(to paypal)
                Store.commit('loading', true)
                hostedFieldsInstance.submit().then(() => {
                  // capture(to paypal)
                  fetch(`https://api-m.sandbox.paypal.com/v2/checkout/orders/${orderId}/capture`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${authToken}`,
                      'PayPal-Request-Id': requestId
                    }
                  }).then((res) => {
                    if (!res) {
                      Store.commit('loading', false)
                      err = 'submit'
                      return alert(Locale.payment_system_error)
                    }
                    return res.json()
                  }).then((orderData) => {
                    // Two cases to handle:
                    //   (1) Non-recoverable errors -> Show a failure message
                    //   (2) Successful transaction -> Show confirmation or thank you
                    // This example reads a v2/checkout/orders capture response, propagated from the server
                    // You could use a different API or structure for your 'orderData'
                    var errorDetail =
                      Array.isArray(orderData.details) && orderData.details[0]
                    if (errorDetail) {
                      var msg = 'Sorry, your transaction could not be processed.'
                      if (errorDetail.description) { msg += '\n\n' + errorDetail.description }
                      if (orderData.debug_id) msg += ' (' + orderData.debug_id + ')'
                      Store.commit('loading', false)
                      err = 'capture'
                      return alert(msg) // Show a failure message
                    }
                    // Show a success message or redirect
                    // alert('Transaction completed!')
                    return orderData
                  }).then((orderData) => {
                    // 결제완료 후 백엔드에 데이터 전송
                    fetch(successUrl, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(orderData)
                    }).then((res) => {
                      // 완료 리턴 ?commerce=1&orderId=R20540&orderStatus=true&orderReason=paid
                      // 후 return url to complete page
                      const url = returnURL.split('?')
                      const returnPath = `${url[0]}?commerce=1&orderId=${Moid}&orderStatus=true&orderReason=paid&${url[1]}`
                      const captureFail = `${url[0]}?commerce=1&orderId=${Moid}&orderStatus=true&orderReason=approval-fail&${url[1]}`
                      const submitFail = `${url[0]}?commerce=1&orderId=${Moid}&orderStatus=true&orderReason=system-error&${url[1]}`
                      window.location.href = err === 'capture'
                        ? captureFail
                        : err === 'submit'
                          ? submitFail
                          : returnPath
                      Store.commit('loading', false)
                    }).catch(() => {
                      alert(Locale.alert_system_error)
                      Store.commit('loading', false)
                    })
                  }).catch(() => {
                    alert(Locale.alert_system_error)
                    Store.commit('loading', false)
                  })
                })
              }
            })
          })
        } catch (error) {
          console.error('failed to render the PayPal Buttons', error)
        }
      } else {
        if (document.querySelector('#paypal-credit')) {
          document.querySelector('#paypal-credit').style = 'display: none'
        }
        alert('failed to load the PayPal JS SDK script')
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#card-form {
  .row {
    display: flex;
    margin-bottom: 12px;
  }
  .cell {
    flex: 1;
    & + .cell {
      margin-left: 8px;
    }
  }
  .input {
    display: block;
    position: relative;
    height: 45px;
    padding-right: 30px;
    border-color: $color-lgrey2;
    border-radius: 4px;
    &:after {
      display: none;
      content: "";
      position: absolute;
      top: 50%;
      right: 14px;
      width: 6px;
      height: 10px;
      margin-top: -8px;
      border-bottom: 2px solid $color-red;
      border-right: 2px solid $color-red;
      transform: rotate(45deg);
    }
    &[class*=isInvalid] {
      border-color: $color-red;
      &:after {
        display: block;
      }
    }
    &[class*=isValid] {
      border-color: $color-green;
      &:after {
        display: block;
        border-color: $color-green;
      }
    }
  }
  .cardLabel {
    margin-bottom: 0.3em;
    font-size: 0.85em;
    color: $color-grey;
  }
}
.paymentLayer {
  z-index: 9999999;
  .inner {
    padding: 45px 15px 30px;
    border-radius: 8px;
  }
  .layerTitle {
    margin-bottom: 30px;
    text-align: center;
  }
  .btn {
    border-radius: 4px;
  }
}
</style>
